import { HelperContext } from "../../Helper/helper.context";

import ImgHelpEvent from '../../../images/help_context/window_event.png';

export const EventHelpContext = ({onClose}) => {
    return (
        <HelperContext 
        onClose={onClose}
        children={
            <div style={{position: "relative", flexGrow: 1}}>
                <div className="text-center">
                    <img src={ImgHelpEvent}/>
                </div>
            </div>
        }
    />    
)}